import { ContextProvider, Form } from '@sravni/react-silent-authentication-form';
import React from 'react';

import { FORM_ID } from '../constants';
import type { AuthInlineFormWithContextProviderProps } from '../types';

import { AuthInlineFormView } from './AuthInlineFormView';

export const AuthInlineFormProvider = React.forwardRef<HTMLFormElement, AuthInlineFormWithContextProviderProps>(
  (props, ref) => {
    const {
      metaInfo,
      userManager,
      consentsScreenTitle,
      advertisingBanner,
      advertisingCheckboxLabel,
      getOTPButtonProps,
      isEnabledEmailField,
      isEnabledNameField,
      onChangePhoneClick,
      onChangeAgreementPersonalData,
      onChangeAgreementAdvertising,
      onScreenChange,
      children,
      onClose,
      onConsentsScreenOpen,
      onOTPScreenOpen,
      onConsentsSubmitClick,
      isOTPButtonSticky,
      isEnabledOTPButtonSticky,
      onGetNewOTPClick,
      onInvalidSmsCodeError,
      ...rest
    } = props;

    return (
      <ContextProvider
        metaInfo={metaInfo}
        userManager={userManager}
      >
        <Form
          {...rest}
          id={FORM_ID}
          ref={ref}
        >
          <AuthInlineFormView
            consentsScreenTitle={consentsScreenTitle}
            getOTPButtonProps={getOTPButtonProps}
            advertisingBanner={advertisingBanner}
            advertisingCheckboxLabel={advertisingCheckboxLabel}
            isEnabledNameField={isEnabledNameField}
            isEnabledEmailField={isEnabledEmailField}
            onChangePhoneClick={onChangePhoneClick}
            onChangeAgreementPersonalData={onChangeAgreementPersonalData}
            onChangeAgreementAdvertising={onChangeAgreementAdvertising}
            onScreenChange={onScreenChange}
            onClose={onClose}
            onConsentsScreenOpen={onConsentsScreenOpen}
            onOTPScreenOpen={onOTPScreenOpen}
            onConsentsSubmitClick={onConsentsSubmitClick}
            isOTPButtonSticky={isOTPButtonSticky}
            isEnabledOTPButtonSticky={isEnabledOTPButtonSticky}
            onGetNewOTPClick={onGetNewOTPClick}
            onInvalidSmsCodeError={onInvalidSmsCodeError}
          >
            {children}
          </AuthInlineFormView>
        </Form>
      </ContextProvider>
    );
  },
);

AuthInlineFormProvider.displayName = 'AuthInlineForm';
